import { find } from 'lodash/collection';
import Moment from 'moment';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

const DAY_MAP = {
  0: 'S',
  1: 'M',
  2: 'T',
  3: 'W',
  4: 'T',
  5: 'F',
  6: 'S',
};
const WEEKEND_MAP = {
  0: true,
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: true,
};
const MONTH_MAP = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December',
};

export class Date {
  constructor(value) {
    this.value = moment(value);
  }

  format(args) {
    return this.value.format(args);
  }

  equals(date) {
    if (date) {
      return this.value.isSame(date.value);
    }
    return false;
  }

  get month() {
    return this.value.month();
  }

  get date() {
    return this.value.date();
  }

  get isWeekend() {
    return WEEKEND_MAP[this.value.day()];
  }

  get dayInitial() {
    return DAY_MAP[this.value.day()];
  }
}

export class DateRange {
  constructor(value) {
    if (moment.isRange(value)) {
      this.value = value;
    } else {
      this.value = moment.range(value);
    }
  }

  equals(date) {
    if (date) {
      return this.value.contains(date.value);
    }
    return false;
  }
}

export class Month {
  dates = [];

  constructor(value) {
    this.value = value;
  }

  addDate(date) {
    this.dates.push(date);
  }

  get name() {
    return MONTH_MAP[this.value];
  }

  get datesLength() {
    return this.dates.length;
  }
}

export class DateList {
  dates = [];

  constructor(data) {
    this.dates = data.map(date => {
      if (moment.isMoment(date) || typeof date === 'string') {
        return new Date(date);
      }
      return new DateRange(date);
    });
  }

  includes(date) {
    let includes = false;
    this.dates.forEach(d => {
      if (d.equals(date)) {
        includes = true;
      }
    });
    return includes;
  }

  get raw() {
    return this.dates.map(date => date.value);
  }
}

export default class Calendar {
  months = [];
  dates = [];

  constructor(data) {
    this.loadCalendar(data);
  }

  loadCalendar(data) {
    data.forEach(date => {
      const newDate = new Date(date);
      this.dates.push(newDate);

      const monthValue = newDate.month;
      const month = find(this.months, m => m.value === monthValue);

      if (!month) {
        const newMonth = new Month(monthValue);
        newMonth.addDate(newDate);
        this.months.push(newMonth);
      } else {
        month.addDate(newDate);
      }
    });
  }

  getByMonthAndDate(month, date) {
    return find(this.dates, d => {
      return d.value.month() + 1 === Number(month) && d.value.date() === Number(date);
    });
  }

  get datesLength() {
    return this.dates.length;
  }
}
